<div class="main-content table-page table-page--compact hom">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Homologación de Modelos IA</h1>
        <p>Qué versión de un modelo sirve para desarrollo: lo que se evaluó, lo que se esperaba y lo que se obtuvo, contra el modelo vigente.</p>
      </div>
      @if (pestana === "modelos") {
        <button type="button" class="app-form-btn app-form-btn--primary" (click)="registrar()">
          <i class="material-icons" aria-hidden="true">add</i>
          <span>Registrar modelo</span>
        </button>
      } @else {
        <button type="button" class="app-form-btn app-form-btn--secondary" (click)="volverAModelos()">
          <i class="material-icons" aria-hidden="true">arrow_back</i>
          <span>Modelos</span>
        </button>
      }
    </section>

    <nav class="hom-pestanas" aria-label="Secciones">
      <button type="button" class="hom-pestanas__item" [class.is-activa]="pestana === 'modelos'" [attr.aria-current]="pestana === 'modelos' ? 'page' : null" (click)="volverAModelos()">1 · Modelos</button>
      <button type="button" class="hom-pestanas__item" [class.is-activa]="pestana === 'resultado'" [attr.aria-current]="pestana === 'resultado' ? 'page' : null" [disabled]="!resultado && !sinEvaluaciones" (click)="irAResultado()">2 · Resultado</button>
      <button type="button" class="hom-pestanas__item" [class.is-activa]="pestana === 'comparativa'" [attr.aria-current]="pestana === 'comparativa' ? 'page' : null" (click)="irAComparativa()">3 · Comparativa</button>
    </nav>

    <!-- ============================== 1 · Modelos ============================== -->
    @if (pestana === "modelos") {
      <section class="hom-kpis" aria-label="Indicadores">
        <article class="hom-kpi">
          <span class="hom-kpi__etiqueta">Modelo vigente</span>
          <strong class="hom-kpi__valor hom-kpi__valor--texto">{{ kpis.vigente || "Ninguno todavía" }}</strong>
          @if (kpis.vigente && kpis.vigenteConfiguracion) {
            <span class="hom-kpi__nota">{{ kpis.vigenteConfiguracion }}</span>
          }
          <span class="hom-kpi__nota">
            @if (num(kpis.vigenteCapacidad) !== null) {
              capacidad {{ kpis.vigenteCapacidad | number: "1.1-1" }}
            } @else {
              lo pone un dictamen «Adoptar» firmado
            }
          </span>
        </article>
        <article class="hom-kpi">
          <span class="hom-kpi__etiqueta">Modelos registrados</span>
          <strong class="hom-kpi__valor">{{ kpis.modelos ?? 0 }}</strong>
          <span class="hom-kpi__nota">sin contar retirados</span>
        </article>
        <article class="hom-kpi">
          <span class="hom-kpi__etiqueta">Evaluaciones cargadas</span>
          <strong class="hom-kpi__valor">{{ kpis.evaluaciones ?? 0 }}</strong>
          <span class="hom-kpi__nota">sin las reemplazadas</span>
        </article>
        <article class="hom-kpi">
          <span class="hom-kpi__etiqueta">Pendientes de dictamen</span>
          <strong class="hom-kpi__valor">{{ kpis.pendientes ?? 0 }}</strong>
          <span class="hom-kpi__nota">cargadas y sin firmar</span>
        </article>
      </section>

      <section class="table-page__card">
        <div class="table-page__table-wrap">
          @if (modelos.length) {
            <table class="table-page__table hom-tabla">
              <thead>
                <tr>
                  <th scope="col">Modelo</th>
                  <th scope="col">Identificador</th>
                  <th scope="col">Situación</th>
                  <th scope="col">Última evaluación</th>
                  <th scope="col" class="table-page__actions-head">Acciones</th>
                </tr>
              </thead>
              <tbody>
                @for (m of modelosPagina; track m.idModelo) {
                  <tr>
                    <td>
                      <div class="table-page__cell-stack">
                        <span class="table-page__name">{{ m.nombre }}</span>
                        <span class="table-page__subtext">{{ m.proveedor || "Sin proveedor" }}</span>
                        @if (m.configuraciones) {
                          <span class="table-page__subtext">{{ m.configuraciones }} {{ m.configuraciones === 1 ? "configuración evaluada" : "configuraciones evaluadas" }}</span>
                        }
                        @if (m.fichaVerificado) {
                          <span class="table-page__subtext">Ficha del catálogo · verificada el {{ fechaDmy(m.fichaVerificado) }}</span>
                        }
                      </div>
                    </td>
                    <td><code class="hom-mono">{{ m.identificador }}</code></td>
                    <td>
                      <div class="table-page__cell-stack">
                        <span class="table-page__status-badge" [class]="'table-page__status-badge ' + situacionClase(m.situacion)">{{ situacionTexto(m.situacion) }}</span>
                        @if (m.situacion === "VIGENTE" && m.configuracionVigente) {
                          <span class="table-page__subtext">{{ m.configuracionVigente }}</span>
                        }
                      </div>
                    </td>
                    <td>
                      @if (m.ultimaEvaluacion; as u) {
                        <div class="table-page__cell-stack">
                          <span class="table-page__text">
                            {{ u.fechaCarga }} ·
                            @if (num(u.capacidad) !== null) { <strong>{{ u.capacidad | number: "1.1-1" }}</strong> } @else { — }
                          </span>
                          <span class="table-page__subtext">{{ veredictoTexto(u.veredicto) }} {{ coletilla(u) }}</span>
                          @if (u.nombreConfiguracion) {
                            <span class="table-page__subtext">{{ u.nombreConfiguracion }}</span>
                          }
                        </div>
                      } @else {
                        <span class="table-page__subtext">Sin evaluaciones</span>
                      }
                    </td>
                    <td class="table-page__actions table-page__actions--multi">
                      <div class="table-page__action-group">
                        <button type="button" class="table-page__action-btn" [attr.aria-label]="'Ver resultado de ' + m.nombre" title="Ver resultado" (click)="verResultado(m)">
                          <i class="material-icons" aria-hidden="true">insights</i>
                        </button>
                        <button type="button" class="table-page__action-btn" [attr.aria-label]="'Cargar evaluación de ' + m.nombre" title="Cargar evaluación" [disabled]="m.activo === false" (click)="abrirCarga(m)">
                          <i class="material-icons" aria-hidden="true">upload_file</i>
                        </button>
                        <button type="button" class="table-page__action-btn" [attr.aria-label]="'Cargar ficha del catálogo de ' + m.nombre" title="Cargar ficha del catálogo" [disabled]="m.activo === false" (click)="abrirCargaFicha(m)">
                          <i class="material-icons" aria-hidden="true">menu_book</i>
                        </button>
                        <button type="button" class="table-page__action-btn" [attr.aria-label]="'Editar ' + m.nombre" title="Editar" (click)="editar(m)">
                          <i class="material-icons" aria-hidden="true">edit</i>
                        </button>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          } @else if (cargandoLista) {
            <div class="table-page__empty">
              <i class="material-icons" aria-hidden="true">hourglass_top</i>
              <strong>Cargando modelos…</strong>
            </div>
          } @else if (errorLista) {
            <div class="table-page__empty" role="alert">
              <i class="material-icons" aria-hidden="true">error_outline</i>
              <strong>{{ errorLista }}</strong>
              <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="cargarModelos()">Reintentar</button>
            </div>
          } @else {
            <div class="table-page__empty">
              <i class="material-icons" aria-hidden="true">fact_check</i>
              <strong>Todavía no hay modelos registrados</strong>
              <span>Registra el modelo en uso y después carga su homologación.</span>
            </div>
          }
        </div>

        @if (modelos.length > POR_PAGINA) {
          <div class="table-page__footer">
            <div class="table-page__meta"><span>{{ rango }}</span></div>
            <div class="table-page__pager">
              <button type="button" class="table-page__pager-link" [disabled]="pagina === 1" (click)="irAPagina(pagina - 1)">Anterior</button>
              @for (n of paginas; track n) {
                <button type="button" class="table-page__pager-page" [class.is-current]="n === pagina" [attr.aria-current]="n === pagina ? 'page' : null" (click)="irAPagina(n)">{{ n }}</button>
              }
              <button type="button" class="table-page__pager-link" [disabled]="pagina === totalPaginas" (click)="irAPagina(pagina + 1)">Siguiente</button>
            </div>
          </div>
        }
      </section>
    }

    <!-- ============================== 2 · Resultado ============================== -->
    @if (pestana === "resultado") {
      @if (cargandoResultado) {
        <section class="table-page__card">
          <div class="table-page__empty">
            <i class="material-icons" aria-hidden="true">hourglass_top</i>
            <strong>Abriendo el resultado…</strong>
          </div>
        </section>
      } @else if (errorResultado) {
        <section class="table-page__card">
          <div class="table-page__empty" role="alert">
            <i class="material-icons" aria-hidden="true">error_outline</i>
            <strong>{{ errorResultado }}</strong>
          </div>
        </section>
      } @else if (sinEvaluaciones) {
        <section class="table-page__card">
          <div class="table-page__empty">
            <i class="material-icons" aria-hidden="true">inventory_2</i>
            <strong>{{ sinEvaluaciones.nombre }}: sin evaluaciones cargadas</strong>
            <span>Carga el archivo que exporta <code class="hom-mono">homologa exportar</code> para ver qué se evaluó y qué se obtuvo.</span>
            @if (sinEvaluaciones.activo !== false) {
              <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact" (click)="cargarDesdeResultado()">Cargar evaluación</button>
              <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="cargarFichaDesdeResultado()">
                {{ fichasAbiertas?.ficha ? "Reemplazar ficha del catálogo" : "Cargar ficha del catálogo" }}
              </button>
            }
          </div>
        </section>
        <!-- Sin evaluaciones también puede tener ficha del catálogo: informa, no califica (spec 5.8) -->
        @if (fichasAbiertas; as d) {
          @if (d.ficha) {
            <app-ficha-catalogo [ficha]="d.ficha"></app-ficha-catalogo>
          }
          @if (d.fichas.length) {
            <section class="hom-card hom-fichas-sueltas">
              <ng-container *ngTemplateOutlet="historialFichas; context: { $implicit: d }"></ng-container>
            </section>
          }
        }
      } @else if (resultado) {
        @let e = resultado.evaluacion;

        <!-- Encabezado: el veredicto del harness es una recomendación, no el dictamen -->
        <section class="hom-card hom-encabezado">
          <div class="hom-encabezado__fila">
            <div class="hom-encabezado__titulos">
              <p class="hom-kicker">Resultado de la homologación</p>
              <h2 class="hom-h2">{{ resultado.modelo?.nombre || e.modelo }}</h2>
            </div>
            <span class="table-page__status-badge hom-veredicto" [class]="'table-page__status-badge hom-veredicto ' + veredictoClase(e.veredicto)">
              {{ veredictoTexto(e.veredicto) }} {{ coletilla(e) }}
            </span>
          </div>
          <p class="hom-encabezado__linea">
            {{ e.nombreConfiguracion }} · <code class="hom-mono">{{ e.identificador }}</code> · corrida <code class="hom-mono">{{ e.runId }}</code> · {{ e.repeticiones }} rep.
          </p>
          <p class="hom-encabezado__linea hom-encabezado__linea--suave">
            @if (e.esBaseline) {
              Es el baseline de su vara: las siguientes homologaciones se comparan contra él.
            } @else if (resultado.baseline) {
              Comparado contra {{ resultado.baseline.modelo }} · corrida <code class="hom-mono">{{ resultado.baseline.runId }}</code>
            } @else {
              Sin baseline: se ve sin deltas.
            }
          </p>
          @if (e.dictamen) {
            <p class="hom-encabezado__dictamen">
              <strong>Dictamen:</strong> {{ dictamenTexto(e.dictamen) }} · firmado por {{ e.firmo || "—" }} el {{ e.fechaFirma }}
            </p>
          }
          @if (razones.length) {
            <ul class="hom-razones">
              @for (r of razones; track $index) {
                <li>{{ r }}</li>
              }
            </ul>
          }
          @if (!legible) {
            <p class="hom-aviso" role="status">Este archivo es de una versión del formato que esta pantalla no sabe leer a detalle: se ve el núcleo tipado.</p>
          }
          @if (baselineReemplazado) {
            <p class="hom-aviso" role="status">
              Su baseline se recalificó después (la evaluación #{{ e.idEvalBaseline }} quedó reemplazada): los deltas son contra una calificación que ya no vale. Hay que recalificarla con <code class="hom-mono">--contra</code> y volver a cargarla; así no se firma ni entra a la comparativa.
            </p>
          }
        </section>

        <!-- Ficha del catálogo: informa, no califica (spec 5.8). Los precios se comparan contra los de ESTA evaluación -->
        @if (fichasAbiertas?.ficha; as fx) {
          <app-ficha-catalogo
            [ficha]="fx"
            [preciosEval]="{ idEval: e.idEval, entrada: e.precioEntradaUsd, salida: e.precioSalidaUsd, cacheLectura: e.precioCacheLecturaUsd }"
          ></app-ficha-catalogo>
        }

        <!-- KPIs: cada uno con su delta contra el baseline -->
        <section class="hom-kpis hom-kpis--seis" aria-label="Indicadores del resultado">
          <article class="hom-kpi">
            <span class="hom-kpi__etiqueta">Capacidad</span>
            <strong class="hom-kpi__valor">@if (num(e.capacidad) !== null) { {{ e.capacidad | number: "1.1-1" }} } @else { — }</strong>
            @if (!e.esBaseline && num(e.deltaCapacidad) !== null) {
              <span class="hom-kpi__delta" [attr.data-signo]="signo(e.deltaCapacidad)">{{ conSigno(e.deltaCapacidad) }} pts vs baseline</span>
            }
          </article>
          <article class="hom-kpi">
            <span class="hom-kpi__etiqueta">Costo por tarea resuelta</span>
            <strong class="hom-kpi__valor">@if (num(e.costoPorTareaUsd) !== null) { $ {{ e.costoPorTareaUsd | number: "1.2-2" }} } @else { — }</strong>
            @if (!e.esBaseline && num(e.costoRelativo) !== null) {
              <span class="hom-kpi__nota">{{ veces(e.costoRelativo) }} el del baseline</span>
            }
          </article>
          <article class="hom-kpi">
            <span class="hom-kpi__etiqueta">Latencia p95</span>
            <strong class="hom-kpi__valor">@if (num(e.latenciaP95S) !== null) { {{ e.latenciaP95S | number: "1.0-1" }} s } @else { — }</strong>
            @if (!e.esBaseline && num(e.p95Relativo) !== null) {
              <span class="hom-kpi__nota">{{ veces(e.p95Relativo) }} la del baseline</span>
            }
          </article>
          <article class="hom-kpi">
            <span class="hom-kpi__etiqueta">Consistencia</span>
            <strong class="hom-kpi__valor">@if (num(e.consistenciaScore) !== null) { {{ e.consistenciaScore | number: "1.1-1" }} } @else { — }</strong>
            <span class="hom-kpi__nota">@if (num(e.consistenciaDesv) !== null) { σ {{ e.consistenciaDesv | number: "1.2-2" }} } @else { no medida }</span>
          </article>
          <article class="hom-kpi">
            <span class="hom-kpi__etiqueta">Tareas resueltas</span>
            <strong class="hom-kpi__valor">{{ e.tareasResueltas }} / {{ e.tareasTotales }}</strong>
            <span class="hom-kpi__nota">{{ e.ejecucionesValidas }} {{ e.ejecucionesValidas === 1 ? "ejecución válida" : "ejecuciones válidas" }} @if (e.fallasInfra) { · {{ e.fallasInfra }} {{ e.fallasInfra === 1 ? "falla" : "fallas" }} }</span>
          </article>
          <article class="hom-kpi">
            <span class="hom-kpi__etiqueta">Costo total · tokens</span>
            <strong class="hom-kpi__valor">@if (num(e.costoTotalUsd) !== null) { $ {{ e.costoTotalUsd | number: "1.2-2" }} } @else { — }</strong>
            <span class="hom-kpi__nota">{{ tokensK(e.tokensTotales) }} tokens</span>
          </article>
        </section>

        <!-- Condiciones eliminatorias -->
        <section class="hom-card">
          <h3 class="hom-h3">Condiciones eliminatorias</h3>
          <div class="hom-tabla-caja">
            <table class="table-page__table hom-interna hom-gates">
              <thead>
                <tr>
                  <th scope="col">Estado</th>
                  <th scope="col">Condición</th>
                  <th scope="col">Valor</th>
                  <th scope="col">Umbral</th>
                  <th scope="col">Qué verifica</th>
                </tr>
              </thead>
              <tbody>
                @for (g of e.gates || []; track g.gate) {
                  <tr [attr.data-estado]="g.estado">
                    <td>
                      <span class="hom-gate" [attr.data-estado]="g.estado">
                        <i class="material-icons" aria-hidden="true">{{ gateIcono(g.estado) }}</i>
                        {{ gateTexto(g.estado) }}
                      </span>
                    </td>
                    <td><code class="hom-mono">{{ g.gate }}</code></td>
                    <td class="hom-num">@if (num(g.valor) !== null) { {{ g.valor | number: "1.0-2" }} } @else { — }</td>
                    <td class="hom-num">{{ g.umbral || "—" }}</td>
                    <td>
                      {{ g.descripcion || "—" }}
                      @if (g.detalle) {
                        <span class="table-page__subtext hom-gate__detalle">{{ g.detalle }}</span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </section>

        <!-- Capacidad por área: radar y tabla con los números -->
        <section class="hom-card">
          <h3 class="hom-h3">Capacidad por área</h3>
          <div class="hom-area">
            <div class="hom-area__radar">
              <app-radar-rubros [etiquetas]="etiquetasRadar" [series]="seriesRadar"
                [descripcion]="'Capacidad por rubro de ' + (resultado.modelo?.nombre || e.modelo)"></app-radar-rubros>
            </div>
            <div class="hom-tabla-caja hom-area__tabla">
              <table class="table-page__table hom-interna">
                <thead>
                  <tr>
                    <th scope="col">Rubro</th>
                    <th scope="col" class="hom-num">Peso</th>
                    <th scope="col" class="hom-num">Obtenido</th>
                    @if (!e.esBaseline) {
                      <th scope="col" class="hom-num">Baseline</th>
                      <th scope="col" class="hom-num">Δ</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (r of e.rubros || []; track r.rubro) {
                    <tr>
                      <td>
                        <div class="table-page__cell-stack">
                          <span class="table-page__text">{{ r.nombre }}</span>
                          @if (r.queMide) {
                            <span class="table-page__subtext">{{ r.queMide }}</span>
                          }
                        </div>
                      </td>
                      <td class="hom-num">{{ r.peso * 100 | number: "1.1-1" }}%</td>
                      <td class="hom-num"><strong>@if (num(r.valor) !== null) { {{ r.valor | number: "1.1-1" }} } @else { no aplica }</strong></td>
                      @if (!e.esBaseline) {
                        <td class="hom-num">@if (num(r.valorBaseline) !== null) { {{ r.valorBaseline | number: "1.1-1" }} } @else { — }</td>
                        <td class="hom-num"><span class="hom-delta" [attr.data-signo]="signo(r.delta)">{{ conSigno(r.delta) }}</span></td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </section>

        @if (tareasDoc.length) {
          <!-- Matriz tarea x rubro -->
          <section class="hom-card">
            <h3 class="hom-h3">Matriz tarea × rubro</h3>
            <p class="hom-nota">Celdas coloreadas por valor; vacía = no aplica.</p>
            <app-matriz-tarea-rubro [tareas]="tareasDoc" [rubros]="rubrosMatriz"></app-matriz-tarea-rubro>
          </section>

          <!-- Qué se evaluó -->
          <section class="hom-card">
            <h3 class="hom-h3">Qué se evaluó · {{ tareasDoc.length }} {{ tareasDoc.length === 1 ? "tarea" : "tareas" }}</h3>
            <div class="hom-tareas">
              @for (t of tareasDoc; track $index) {
                <app-tarea-detalle [tarea]="t" [nombresRubro]="nombresRubro"></app-tarea-detalle>
              }
            </div>
          </section>
        } @else {
          <!-- Sin el documento legible: la capacidad por tarea sale de lo tipado -->
          <section class="hom-card">
            <h3 class="hom-h3">Capacidad por tarea</h3>
            <div class="hom-tabla-caja">
              <table class="table-page__table hom-interna">
                <thead><tr><th scope="col">Tarea</th><th scope="col" class="hom-num">Capacidad</th><th scope="col">Resuelta</th></tr></thead>
                <tbody>
                  @for (t of e.tareas || []; track t.tareaId) {
                    <tr>
                      <td>{{ t.nombre }}</td>
                      <td class="hom-num">@if (num(t.capacidadMedia) !== null) { {{ t.capacidadMedia | number: "1.1-1" }} } @else { — }</td>
                      <td>{{ t.resuelta ? "Sí" : "No" }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </section>
        }

        <!-- Procedencia -->
        <section class="hom-card">
          <h3 class="hom-h3">Procedencia</h3>
          <dl class="hom-procedencia">
            <div><dt>Hash de rúbrica</dt><dd><code class="hom-mono">{{ e.hashRubrica }}</code> @if (e.perfilRubrica) { · {{ e.perfilRubrica }} {{ e.versionRubrica }} }</dd></div>
            <div><dt>Hash de suite</dt><dd><code class="hom-mono">{{ e.hashSuite }}</code></dd></div>
            <div><dt>Hash de prompts</dt><dd><code class="hom-mono">{{ e.hashPrompts }}</code></dd></div>
            <div><dt>Aplicada</dt><dd>{{ e.aplicadaDesde || "—" }} → {{ e.aplicadaHasta || "—" }} @if (e.aplicadaEn) { · {{ e.aplicadaEn }} }</dd></div>
            <div><dt>Calificada</dt><dd>{{ e.calificadaHasta || "—" }}</dd></div>
            <div class="hom-procedencia__ancho"><dt>Calificación en git</dt><dd><code class="hom-mono">{{ e.ramaCalificacion || "—" }}</code> @if (e.commitCalificacion) { · <code class="hom-mono">{{ e.commitCalificacion }}</code> } @if (e.repoCalificacion) { <span class="table-page__subtext">{{ e.repoCalificacion }}</span> }</dd></div>
            <div class="hom-procedencia__ancho"><dt>Exportación en git</dt><dd>@if (e.ramaExportacion) { <code class="hom-mono">{{ e.ramaExportacion }}</code> <span class="table-page__subtext">{{ e.repoExportacion }}</span> } @else { No se publicó (exportado con --no-publicar). }</dd></div>
            <div class="hom-procedencia__ancho"><dt>Huella SHA-256 del archivo</dt><dd><code class="hom-mono hom-mono--corta">{{ e.sha256Archivo }}</code></dd></div>
            <div><dt>Archivo</dt><dd>{{ e.nombreArchivo }} · {{ kb(e.tamanoBytes) }} · formato v{{ e.versionFormato }}</dd></div>
            <div><dt>Cargó</dt><dd>{{ e.cargo || "—" }} · {{ e.fechaCarga }}</dd></div>
            @if (e.idEvalReemplazada) {
              <div class="hom-procedencia__ancho"><dt>Reemplazó a</dt><dd>la evaluación #{{ e.idEvalReemplazada }}. Motivo: {{ e.motivoReemplazo }}</dd></div>
            }
          </dl>
          <div class="hom-acciones">
            <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" [disabled]="descargando" (click)="descargar()">
              <i class="material-icons" aria-hidden="true">download</i>
              {{ descargando ? "Bajando…" : "Descargar archivo original" }}
            </button>
            @if (resultado.modelo?.activo !== false) {
              <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="cargarDesdeResultado()">
                <i class="material-icons" aria-hidden="true">upload_file</i>
                Cargar otra evaluación
              </button>
              <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="cargarFichaDesdeResultado()">
                <i class="material-icons" aria-hidden="true">menu_book</i>
                {{ fichasAbiertas?.ficha ? "Reemplazar ficha del catálogo" : "Cargar ficha del catálogo" }}
              </button>
            }
          </div>

          @if (configuracionesDelModelo.length > 1) {
            <details class="hom-anteriores" open>
              <summary>Configuraciones de este modelo ({{ configuracionesDelModelo.length }})</summary>
              <ul>
                @for (cfg of configuracionesDelModelo; track cfg.evaluacion.idEval) {
                  @let x = cfg.evaluacion;
                  <li [class.is-actual]="x.candidatoId === e.candidatoId">
                    <button type="button" class="hom-enlace" [disabled]="x.idEval === e.idEval" (click)="abrirResultado(x.idEval, resultado.modelo)">
                      {{ x.nombreConfiguracion || x.candidatoId }}
                    </button>
                    <span class="table-page__subtext">
                      @if (cfg.vigente) { <strong>Vigente</strong> · }
                      última: #{{ x.idEval }} · {{ x.fechaCarga }} · {{ veredictoTexto(x.veredicto) }} {{ coletilla(x) }} ·
                      @if (num(x.capacidad) !== null) { {{ x.capacidad | number: "1.1-1" }} } @else { — }
                    </span>
                  </li>
                }
              </ul>
            </details>
          }

          @if (resultado.evaluaciones.length > 1) {
            <details class="hom-anteriores">
              <summary>Evaluaciones de este modelo ({{ resultado.evaluaciones.length }})</summary>
              <ul>
                @for (x of resultado.evaluaciones; track x.idEval) {
                  <li [class.is-actual]="x.idEval === e.idEval">
                    <button type="button" class="hom-enlace" [disabled]="x.idEval === e.idEval" (click)="abrirResultado(x.idEval, resultado.modelo)">
                      #{{ x.idEval }} · corrida <code class="hom-mono">{{ x.runId }}</code> · {{ x.fechaCarga }}
                    </button>
                    <span class="table-page__subtext">
                      @if (x.nombreConfiguracion) { {{ x.nombreConfiguracion }} · }
                      {{ veredictoTexto(x.veredicto) }} {{ coletilla(x) }} ·
                      @if (num(x.capacidad) !== null) { {{ x.capacidad | number: "1.1-1" }} } @else { — }
                    </span>
                  </li>
                }
              </ul>
            </details>
          }

          @if (fichasAbiertas; as d) {
            @if (d.fichas.length) {
              <ng-container *ngTemplateOutlet="historialFichas; context: { $implicit: d }"></ng-container>
            }
          }
        </section>

        <!-- Dictamen: el veredicto del harness es una recomendación; decide una persona, con firma digital y PIN -->
        <section class="hom-card hom-dictamen" aria-labelledby="hom-dictamen-titulo">
          <h3 id="hom-dictamen-titulo" class="hom-h3" tabindex="-1">Dictamen</h3>

          @if (e.estatus === "FIRMADA") {
            <div class="hom-dictamen__firmado">
              <div class="hom-dictamen__datos">
                <span class="table-page__status-badge hom-veredicto" [class]="'table-page__status-badge hom-veredicto ' + dictamenClase(e.dictamen)">
                  {{ dictamenTexto(e.dictamen) || "—" }}
                </span>
                <dl class="hom-procedencia">
                  @if (e.dictamenRestricciones) {
                    <div class="hom-procedencia__ancho"><dt>Restricciones</dt><dd class="hom-texto-libre">{{ e.dictamenRestricciones }}</dd></div>
                  }
                  @if (e.dictamenComentario) {
                    <div class="hom-procedencia__ancho"><dt>Comentario</dt><dd class="hom-texto-libre">{{ e.dictamenComentario }}</dd></div>
                  }
                  <div><dt>Firmó</dt><dd>{{ e.firmo || "—" }}</dd></div>
                  <div><dt>Fecha de firma</dt><dd>{{ e.fechaFirma || "—" }}</dd></div>
                  <div><dt>Recomendación del harness</dt><dd>{{ veredictoTexto(e.veredicto) }}</dd></div>
                </dl>
              </div>
              @if (e.firmaDigital) {
                <figure class="hom-dictamen__trazo">
                  <img [src]="e.firmaDigital" [alt]="'Firma digital de ' + (e.firmo || 'quien firmó')" />
                  <figcaption>Firma digital y PIN · {{ e.firmo || "—" }}</figcaption>
                </figure>
              }
            </div>
            @if (avisosFirma.length) {
              <div class="hom-lista hom-lista--aviso" role="status">
                <strong>Avisos al firmar (quedaron en la bitácora):</strong>
                <ul>
                  @for (x of avisosFirma; track $index) {
                    <li>{{ x }}</li>
                  }
                </ul>
              </div>
            }
            @if (puedeAutorizar) {
              <div class="hom-acciones">
                <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="abrirReabrir()">
                  <i class="material-icons" aria-hidden="true">lock_open</i>
                  Reabrir dictamen
                </button>
                <span class="hom-ayuda hom-acciones__nota">Pide motivo y PIN. Se borra la firma; la bitácora guarda cómo estaba firmado.</span>
              </div>
            }
          } @else if (e.estatus === "REEMPLAZADA") {
            <p class="hom-nota">Reemplazada por una recalificación: no se firma. Se firma la calificación que la reemplazó.</p>
            @if (reemplazante; as x) {
              <div class="hom-acciones">
                <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="abrirResultado(x.idEval, resultado.modelo)">
                  Abrir la evaluación #{{ x.idEval }}
                </button>
              </div>
            }
          } @else if (puedeAutorizar) {
            <p class="hom-nota">
              Recomendación del harness: <strong>{{ veredictoTexto(e.veredicto) }}</strong>. Firmar en contra se puede: la bitácora lo registra como decisión contra la recomendación.
            </p>

            <div class="hom-radios" role="radiogroup" aria-label="Dictamen">
              <label class="hom-radio" [class.is-bloqueado]="!adoptable">
                <input type="radio" name="hom-dictamen" class="hom-radio__input" [checked]="captura.eleccion === 'ADOPTAR'" [disabled]="!adoptable" (change)="elegirDictamen('ADOPTAR')" />
                <span class="hom-radio__punto" aria-hidden="true"></span>
                <span class="hom-radio__textos">
                  <span class="hom-radio__titulo">Adoptar</span>
                  <span class="hom-radio__desc">{{ textoAdoptar }}</span>
                </span>
              </label>
              <label class="hom-radio">
                <input type="radio" name="hom-dictamen" class="hom-radio__input" [checked]="captura.eleccion === 'ADOPTAR_CON_RESTRICCIONES'" (change)="elegirDictamen('ADOPTAR_CON_RESTRICCIONES')" />
                <span class="hom-radio__punto" aria-hidden="true"></span>
                <span class="hom-radio__textos">
                  <span class="hom-radio__titulo">Adoptar con restricciones</span>
                  <span class="hom-radio__desc">Se usa solo como dicen las restricciones que escribas. No cambia el modelo vigente.</span>
                </span>
              </label>
              <label class="hom-radio">
                <input type="radio" name="hom-dictamen" class="hom-radio__input" [checked]="captura.eleccion === 'NO_ADOPTAR'" (change)="elegirDictamen('NO_ADOPTAR')" />
                <span class="hom-radio__punto" aria-hidden="true"></span>
                <span class="hom-radio__textos">
                  <span class="hom-radio__titulo">No adoptar</span>
                  <span class="hom-radio__desc">No se usa para desarrollo. La evaluación queda como evidencia.</span>
                </span>
              </label>
            </div>

            <div class="hom-dictamen__campos">
              @if (captura.eleccion === "ADOPTAR_CON_RESTRICCIONES") {
                <div class="hom-campo">
                  <div class="hom-campo__cabeza">
                    <label for="hom-dictamen-restricciones">Restricciones <span class="hom-req" aria-hidden="true">*</span></label>
                    <span class="hom-contador">{{ captura.restricciones.length }}/1000</span>
                  </div>
                  <textarea id="hom-dictamen-restricciones" class="hom-input" rows="3" maxlength="1000" [(ngModel)]="captura.restricciones" placeholder="Solo para generar pruebas unitarias; toda entrega pasa por revisión humana."></textarea>
                </div>
              }
              <div class="hom-campo">
                <div class="hom-campo__cabeza">
                  <label for="hom-dictamen-comentario">Comentario</label>
                  <span class="hom-contador">{{ captura.comentario.length }}/1000</span>
                </div>
                <textarea id="hom-dictamen-comentario" class="hom-input" rows="2" maxlength="1000" [(ngModel)]="captura.comentario"></textarea>
              </div>
            </div>

            @if (sinPin) {
              <p class="hom-nota hom-nota--aviso">
                Para firmar necesitas tu PIN de autorización. Se define una sola vez en
                <a class="hom-liga" href="#/admin/ajustes" target="_blank" rel="noopener">Ajustes</a>, con tu contraseña de COS.
              </p>
            }

            <div class="hom-acciones">
              @if (!baselineReemplazado) {
                <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact" [disabled]="!capturaLista" (click)="abrirFirma()">
                  <i class="material-icons" aria-hidden="true">draw</i>
                  Firmar dictamen
                </button>
              } @else {
                <span class="hom-ayuda hom-acciones__nota">No se firma: su baseline se recalificó después. Recalifícala y vuelve a cargarla.</span>
              }
              <button type="button" class="app-form-btn app-form-btn--danger app-form-btn--compact" (click)="abrirEliminar()">
                <i class="material-icons" aria-hidden="true">delete_outline</i>
                Eliminar evaluación
              </button>
            </div>
          } @else {
            <p class="hom-nota">Sin dictamen. Lo firma un autorizador de Homologación de Modelos IA, con firma digital y PIN.</p>
          }
        </section>
      }
    }

    <!-- ============================= 3 · Comparativa ============================= -->
    @if (pestana === "comparativa") {
      <app-comparativa-modelos (abrir)="abrirResultado($event)"></app-comparativa-modelos>
    }
  </div>

  <!-- El PIN, igual en los tres cuadros que lo piden: firmar, reabrir y eliminar -->
  <ng-template #campoPin let-d let-id="id">
    <div class="hom-campo hom-pin">
      @if (sinPin) {
        <div class="hom-lista hom-lista--aviso" role="alert">
          <strong>Aún no defines tu PIN de autorización.</strong>
          <p class="hom-pin__texto">Se define una sola vez en Ajustes, con tu contraseña de COS. Ábrelo en otra pestaña para no perder lo que capturaste aquí.</p>
          <div class="hom-pin__botones">
            <a class="app-form-btn app-form-btn--secondary app-form-btn--compact" href="#/admin/ajustes" target="_blank" rel="noopener">Abrir Ajustes</a>
            <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="revisarPin()">Ya lo definí</button>
          </div>
        </div>
      } @else if (pinBloqueado) {
        <div class="hom-lista hom-lista--error" role="alert">
          <strong>Tu PIN está bloqueado hasta las {{ pinBloqueado }}.</strong>
          <p class="hom-pin__texto">Por cinco intentos fallidos. Espera a esa hora, o pide a quien administra Empleados que lo restablezca.</p>
          <div class="hom-pin__botones">
            <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="revisarPin()">Revisar de nuevo</button>
          </div>
        </div>
      } @else {
        <label [attr.for]="id">PIN de autorización <span class="hom-req" aria-hidden="true">*</span></label>
        <input [id]="id" class="hom-input hom-pin__campo" type="password" inputmode="numeric" autocomplete="one-time-code" maxlength="8"
          [value]="d.pin" [disabled]="d.enviando" (input)="d.pin = digitos($event)" (keydown.enter)="enterEnPin(d)" />
        <span class="hom-ayuda">El tuyo, de 6 a 8 dígitos. {{ avisoIntentos }}</span>
      }
    </div>
  </ng-template>

  <!-- «Fichas de este modelo»: la vigente primero y las reemplazadas, con motivo, quién y cuándo -->
  <ng-template #historialFichas let-d>
    <details class="hom-anteriores">
      <summary>Fichas de este modelo ({{ d.fichas.length }})</summary>
      <ul>
        @for (f of d.fichas; track f.idFicha) {
          @let por = reemplazoDe(d.fichas, f);
          <li [class.is-actual]="f.estatus === 'VIGENTE'">
            <span class="table-page__text">
              {{ f.estatus === "VIGENTE" ? "Vigente" : "Reemplazada" }} · ficha #{{ f.idFicha }} · verificada el {{ fechaDmy(f.verificado) }}
            </span>
            <span class="table-page__subtext">Cargó {{ f.cargo || "—" }} el {{ f.fechaCarga || "—" }} · {{ f.nombreArchivo || "—" }} · {{ kb(f.tamanoBytes) }}</span>
            @if (por) {
              <span class="table-page__subtext hom-fichas__motivo">Reemplazada por la #{{ por.idFicha }}, que cargó {{ por.cargo || "—" }} el {{ por.fechaCarga || "—" }}. Motivo: {{ por.motivoReemplazo || "—" }}</span>
            } @else if (f.estatus === "REEMPLAZADA") {
              <span class="table-page__subtext">Reemplazada; la que la reemplazó ya se eliminó.</span>
            }
            <span class="hom-fichas__acciones">
              <button type="button" class="hom-enlace" [disabled]="descargandoFicha" [attr.aria-label]="'Descargar la ficha #' + f.idFicha" (click)="descargarFicha(f)">
                {{ descargandoFicha ? "Bajando…" : "Descargar" }}
              </button>
              @if (puedeAutorizar) {
                <button type="button" class="hom-enlace hom-enlace--peligro" [attr.aria-label]="'Eliminar la ficha #' + f.idFicha" (click)="abrirEliminarFicha(f)">Eliminar ficha</button>
              }
            </span>
          </li>
        }
      </ul>
    </details>
  </ng-template>

  <!-- ============================== Firmar dictamen ============================== -->
  @if (firma && resultado) {
    <app-firma-frc
      para="autorizar"
      documento="HOMOLOGACION-IA"
      [soloDigital]="true"
      [nombre]="resultado.modelo?.nombre || resultado.evaluacion.modelo"
      [leyenda]="leyendaFirma"
      [listo]="firmaLista"
      [ocupado]="firma.enviando"
      (firmada)="alFirmar($event)"
      (cancelada)="cerrarFirma()"
      (keydown.tab)="atrapaFoco($event, 'app-firma-frc .ff__caja')"
      (keydown.shift.tab)="atrapaFoco($event, 'app-firma-frc .ff__caja')"
    >
      <div class="hom-firma-pin">
        <ng-container *ngTemplateOutlet="campoPin; context: { $implicit: firma, id: 'hom-firma-pin' }"></ng-container>
        <span class="hom-mensaje" role="alert" data-tono="error">{{ firma.mensaje }}</span>
      </div>
    </app-firma-frc>
  }

  <!-- ========================= Reabrir dictamen / Eliminar ========================= -->
  @if (accionPin) {
    <div class="hom-modal" role="dialog" aria-modal="true" aria-labelledby="hom-accion-titulo" (keydown.tab)="atrapaFoco($event)" (keydown.shift.tab)="atrapaFoco($event)">
      <div class="hom-modal__fondo" (click)="cerrarAccion(true)" (keydown.enter)="cerrarAccion(true)"></div>
      <section class="app-dialog hom-modal__caja">
        <header class="app-dialog__header">
          <div class="app-dialog__heading">
            <div>
              <p class="app-dialog__eyebrow">{{ accionPin.tipo === "reabrir" ? "Reabrir dictamen" : accionPin.tipo === "eliminarFicha" ? "Eliminar ficha del catálogo" : "Eliminar evaluación" }}</p>
              <h2 id="hom-accion-titulo">{{ accionPin.modelo }}</h2>
              @if (accionPin.ficha; as fx) {
                <p>Ficha #{{ fx.idFicha }} · verificada el {{ fechaDmy(fx.verificado) }}</p>
              } @else if (accionPin.evaluacion; as ev) {
                <p>Evaluación #{{ ev.idEval }} · corrida <code class="hom-mono">{{ ev.runId }}</code></p>
              }
            </div>
          </div>
          <button type="button" class="app-dialog__close hom-cerrar" aria-label="Cerrar" [disabled]="accionPin.enviando" (click)="cerrarAccion(true)">
            <i class="material-icons" aria-hidden="true">close</i>
          </button>
        </header>

        <div class="app-dialog__content hom-carga">
          @if (accionPin.tipo === "reabrir" && accionPin.evaluacion; as x) {
            <p class="hom-nota">
              Se borran la firma y el dictamen «{{ dictamenTexto(x.dictamen) }}», firmado por {{ x.firmo || "—" }} el {{ x.fechaFirma || "—" }}.
              La bitácora guarda cómo estaba firmado.
            </p>
            @if (x.dictamen === "ADOPTAR" && resultado?.modelo?.vigente) {
              <div class="hom-lista hom-lista--aviso">
                Si es el único «Adoptar» firmado del modelo, deja de ser el vigente y no queda ninguno hasta que se firme otro.
                @if (x.idEval === resultado?.modelo?.idEvalVigente) {
                  Es la configuración adoptada: si el modelo sigue vigente por otro «Adoptar», se queda sin configuración adoptada hasta que se firme de nuevo.
                }
              </div>
            }
            <div class="hom-campo">
              <div class="hom-campo__cabeza">
                <label for="hom-accion-motivo">Motivo <span class="hom-req" aria-hidden="true">*</span></label>
                <span class="hom-contador">{{ accionPin.motivo.length }}/700</span>
              </div>
              <textarea id="hom-accion-motivo" class="hom-input" rows="3" maxlength="700" [(ngModel)]="accionPin.motivo" [disabled]="accionPin.enviando" placeholder="Se firmó contra el baseline equivocado."></textarea>
            </div>
          } @else if (accionPin.tipo === "eliminarFicha" && accionPin.ficha; as fx) {
            <p class="hom-nota">
              Se borra la ficha con sus listas y benchmarks; su línea en la bitácora del modelo se queda.
              Es para una carga por error. Si es la vigente, la anterior no revive: el modelo queda sin ficha hasta que se cargue otra.
            </p>
            <dl class="hom-resumen">
              <div><dt>Estatus</dt><dd>{{ fx.estatus === "VIGENTE" ? "Vigente" : "Reemplazada" }}</dd></div>
              <div><dt>Verificada</dt><dd>{{ fechaDmy(fx.verificado) }}</dd></div>
              <div class="hom-resumen__ancho"><dt>Archivo</dt><dd>{{ fx.nombreArchivo || "—" }} · {{ kb(fx.tamanoBytes) }}</dd></div>
              <div class="hom-resumen__ancho"><dt>Cargó</dt><dd>{{ fx.cargo || "—" }} · {{ fx.fechaCarga || "—" }}</dd></div>
            </dl>
          } @else if (accionPin.evaluacion; as x) {
            <p class="hom-nota">
              Se borra la evaluación con sus rubros, gates y tareas; su línea en la bitácora del modelo se queda.
              Es para una carga por error: una evaluación firmada, reemplazada o que otra usa como baseline no se elimina.
            </p>
            <dl class="hom-resumen">
              <div><dt>Veredicto del harness</dt><dd>{{ veredictoTexto(x.veredicto) }}</dd></div>
              <div><dt>Capacidad</dt><dd>@if (num(x.capacidad) !== null) { {{ x.capacidad | number: "1.1-1" }} } @else { — }</dd></div>
              <div class="hom-resumen__ancho"><dt>Archivo</dt><dd>{{ x.nombreArchivo }} · {{ kb(x.tamanoBytes) }}</dd></div>
              <div class="hom-resumen__ancho"><dt>Cargó</dt><dd>{{ x.cargo || "—" }} · {{ x.fechaCarga }}</dd></div>
            </dl>
          }

          <ng-container *ngTemplateOutlet="campoPin; context: { $implicit: accionPin, id: 'hom-accion-pin' }"></ng-container>

          <span class="hom-mensaje" role="alert" data-tono="error">{{ mensajeAccion }}</span>
        </div>

        <footer class="app-dialog__footer">
          <button type="button" class="app-form-btn app-form-btn--secondary" [disabled]="accionPin.enviando" (click)="cerrarAccion()">Cancelar</button>
          @if (accionPin.tipo === "reabrir") {
            <button type="button" class="app-form-btn app-form-btn--primary" [disabled]="!accionLista" (click)="confirmarAccion()">
              {{ accionPin.enviando ? "Reabriendo…" : "Reabrir dictamen" }}
            </button>
          } @else {
            <button type="button" class="app-form-btn app-form-btn--danger" [disabled]="!accionLista" (click)="confirmarAccion()">
              {{ accionPin.enviando ? "Eliminando…" : accionPin.tipo === "eliminarFicha" ? "Eliminar ficha" : "Eliminar evaluación" }}
            </button>
          }
        </footer>
      </section>
    </div>
  }

  <!-- ========================= Registrar / Editar modelo ========================= -->
  @if (edicion) {
    <div class="hom-modal" role="dialog" aria-modal="true" aria-labelledby="hom-modelo-titulo" (keydown.tab)="atrapaFoco($event)" (keydown.shift.tab)="atrapaFoco($event)">
      <div class="hom-modal__fondo" (click)="cerrarEdicion(true)" (keydown.enter)="cerrarEdicion(true)"></div>
      <section class="app-dialog hom-modal__caja">
        <header class="app-dialog__header">
          <div class="app-dialog__heading">
            <div>
              <p class="app-dialog__eyebrow">{{ edicion.idModelo == null ? "Registrar modelo" : "Editar modelo" }}</p>
              <h2 id="hom-modelo-titulo">{{ edicion.idModelo == null ? "Modelo nuevo" : edicion.datos.nombre || "Modelo" }}</h2>
              @if (!edicion.activo) {
                <p>Retirado: ya no recibe evaluaciones.</p>
              }
            </div>
          </div>
          <button type="button" class="app-dialog__close hom-cerrar" aria-label="Cerrar" [disabled]="guardandoModelo" (click)="cerrarEdicion(true)">
            <i class="material-icons" aria-hidden="true">close</i>
          </button>
        </header>

        <form class="app-dialog__content hom-form" (ngSubmit)="guardarModelo()" autocomplete="off">
          <div class="hom-campo">
            <div class="hom-campo__cabeza">
              <label for="hom-modelo-nombre">Nombre <span class="hom-req" aria-hidden="true">*</span></label>
              <span class="hom-contador">{{ edicion.datos.nombre.length }}/120</span>
            </div>
            <input id="hom-modelo-nombre" class="hom-input" name="nombre" [(ngModel)]="edicion.datos.nombre" maxlength="120" required [disabled]="guardandoModelo" placeholder="Claude Opus 5.5" />
          </div>

          <div class="hom-campo">
            <div class="hom-campo__cabeza">
              <label for="hom-modelo-identificador">Identificador <span class="hom-req" aria-hidden="true">*</span></label>
              <span class="hom-contador">{{ edicion.datos.identificador.length }}/80</span>
            </div>
            <input id="hom-modelo-identificador" class="hom-input hom-mono" name="identificador" [(ngModel)]="edicion.datos.identificador" maxlength="80" required [disabled]="guardandoModelo || edicion.conEvaluaciones" placeholder="claude-opus-5-5" spellcheck="false" />
            <span class="hom-ayuda">
              @if (edicion.conEvaluaciones) {
                No se cambia: el modelo ya tiene evaluaciones cargadas con este identificador.
              } @else {
                El mismo que va en <code class="hom-mono">--model</code>: cada archivo se valida contra él. Minúsculas, números, punto y guion.
              }
            </span>
          </div>

          <div class="hom-campo">
            <div class="hom-campo__cabeza">
              <label for="hom-modelo-proveedor">Proveedor</label>
              <span class="hom-contador">{{ edicion.datos.proveedor.length }}/120</span>
            </div>
            <input id="hom-modelo-proveedor" class="hom-input" name="proveedor" [(ngModel)]="edicion.datos.proveedor" maxlength="120" [disabled]="guardandoModelo" placeholder="Anthropic" />
          </div>

          <div class="hom-campo hom-campo--ancho">
            <div class="hom-campo__cabeza">
              <label for="hom-modelo-uso">Uso previsto</label>
              <span class="hom-contador">{{ edicion.datos.usoPrevisto.length }}/300</span>
            </div>
            <textarea id="hom-modelo-uso" class="hom-input" name="uso" rows="2" [(ngModel)]="edicion.datos.usoPrevisto" maxlength="300" [disabled]="guardandoModelo"></textarea>
          </div>

          <div class="hom-campo">
            <label for="hom-modelo-inventario">Activo del Inventario IA</label>
            <select id="hom-modelo-inventario" class="hom-input" name="inventario" [(ngModel)]="edicion.datos.idInventarioIa" [disabled]="guardandoModelo">
              <option [ngValue]="null">Sin ligar</option>
              @for (l of inventario; track l.id) {
                <option [ngValue]="l.id">{{ textoLiga(l) }}</option>
              }
            </select>
          </div>

          <div class="hom-campo">
            <label for="hom-modelo-proveedor-eval">Evaluación del proveedor</label>
            <select id="hom-modelo-proveedor-eval" class="hom-input" name="evalProveedor" [(ngModel)]="edicion.datos.idEvalProveedor" [disabled]="guardandoModelo">
              <option [ngValue]="null">Sin ligar</option>
              @for (l of evalProveedores; track l.id) {
                <option [ngValue]="l.id">{{ textoEvalProveedor(l) }}</option>
              }
            </select>
          </div>

          <div class="hom-form__pie">
            <span class="hom-mensaje" role="alert" [attr.data-tono]="tonoModelo">{{ mensajeModelo }}</span>
            <div class="hom-form__botones">
              @if (edicion.idModelo != null && edicion.activo && !edicion.vigente) {
                <button type="button" class="app-form-btn app-form-btn--danger app-form-btn--compact" [disabled]="guardandoModelo" (click)="retirar()">Retirar modelo</button>
              }
              <button type="button" class="app-form-btn app-form-btn--secondary" [disabled]="guardandoModelo" (click)="cerrarEdicion()">Cancelar</button>
              <button type="submit" class="app-form-btn app-form-btn--primary" [disabled]="guardandoModelo || edicionIncompleta || edicionSinCambios">
                {{ guardandoModelo ? "Guardando…" : edicion.idModelo == null ? "Registrar" : "Guardar cambios" }}
              </button>
            </div>
          </div>
        </form>

        @if (edicion.idModelo != null) {
          <div class="hom-bitacora">
            <div class="hom-bitacora__cabeza">
              <span class="hom-bitacora__titulo">Bitácora del modelo</span>
              <span class="hom-bitacora__estado">{{ historialEstado }}</span>
            </div>
            <ol class="hom-bitacora__lista">
              @for (h of historial; track h.idHistorial) {
                <li class="hom-bitacora__item">
                  <span class="hom-bitacora__accion" [attr.data-accion]="h.accion">{{ accionTexto(h.accion) }}</span>
                  <span class="hom-bitacora__detalle">{{ h.detalle }}</span>
                  <span class="hom-bitacora__quien">{{ h.usuario || "—" }} · {{ h.fecha }}</span>
                </li>
              }
            </ol>
          </div>
        }
      </section>
    </div>
  }

  <!-- ============================= Cargar evaluación ============================= -->
  @if (carga) {
    <div class="hom-modal" role="dialog" aria-modal="true" aria-labelledby="hom-carga-titulo" (keydown.tab)="atrapaFoco($event)" (keydown.shift.tab)="atrapaFoco($event)">
      <div class="hom-modal__fondo" (click)="cerrarCarga(true)" (keydown.enter)="cerrarCarga(true)"></div>
      <section class="app-dialog hom-modal__caja hom-modal__caja--ancha hom-modal__caja--carga">
        <header class="app-dialog__header">
          <div class="app-dialog__heading">
            <div>
              <p class="app-dialog__eyebrow">Cargar evaluación</p>
              <h2 id="hom-carga-titulo">{{ carga.modelo.nombre }}</h2>
              <p><code class="hom-mono">{{ carga.modelo.identificador }}</code></p>
            </div>
          </div>
          <button type="button" class="app-dialog__close hom-cerrar" aria-label="Cerrar" [disabled]="carga.cargando" (click)="cerrarCarga(true)">
            <i class="material-icons" aria-hidden="true">close</i>
          </button>
        </header>

        <div class="app-dialog__content hom-carga">
          <!-- En pantallas anchas: a la izquierda elegir y confirmar; a la derecha lo que se leyo. -->
          <div class="hom-carga__control">
            <ol class="hom-pasos" aria-label="Pasos">
              <li [class.is-activo]="!carga.plan" [class.is-hecho]="!!carga.plan">1 · Elegir archivo</li>
              <li [class.is-activo]="!!carga.plan">2 · Confirmar</li>
            </ol>

            <div class="hom-campo">
              <label for="hom-carga-archivo">Archivo de homologación (<code class="hom-mono">homologacion_…json</code>, hasta 5 MB)</label>
              <input id="hom-carga-archivo" type="file" class="hom-input" accept=".json,application/json" [disabled]="carga.revisando || carga.cargando" (change)="alElegirArchivo($event)" />
              <span class="hom-ayuda">Se revisa sin guardar nada. Si todo cuadra, «Cargar» manda el mismo archivo.</span>
            </div>

            @if (carga.revisando) {
              <p class="hom-nota" role="status">Revisando el archivo…</p>
            }

            @if (carga.plan; as p) {
              @if (p.pideMotivo && p.puedeCargar) {
                <div class="hom-campo">
                  <div class="hom-campo__cabeza">
                    <label for="hom-carga-motivo">Motivo del reemplazo <span class="hom-req" aria-hidden="true">*</span></label>
                    <span class="hom-contador">{{ carga.motivo.length }}/700</span>
                  </div>
                  <textarea id="hom-carga-motivo" class="hom-input" rows="2" maxlength="700" [(ngModel)]="carga.motivo" [disabled]="carga.cargando" placeholder="Se recalificó al corregir el calificador."></textarea>
                  <span class="hom-ayuda">La evaluación #{{ p.idEvalReemplaza }} del {{ p.fechaReemplaza }} queda como reemplazada, visible en el historial.</span>
                </div>
              }
            }

            <span class="hom-mensaje" role="alert" [attr.data-tono]="tonoCarga">{{ mensajeCarga }}</span>
          </div>

          @if (carga.plan; as p) {
            <div class="hom-carga__vista">
              <dl class="hom-resumen">
                <div><dt>Corrida</dt><dd><code class="hom-mono">{{ p.runId || "—" }}</code></dd></div>
                <div><dt>Configuración</dt><dd>{{ p.nombreConfiguracion || "—" }}</dd></div>
                <div><dt>Identificador del archivo</dt><dd><code class="hom-mono">{{ p.identificador || "—" }}</code></dd></div>
                <div><dt>Aplicada</dt><dd>{{ p.aplicadaDesde || "—" }} → {{ p.aplicadaHasta || "—" }}</dd></div>
                <div><dt>Calificada</dt><dd>{{ p.calificadaHasta || "—" }}</dd></div>
                <div><dt>Contenido</dt><dd>{{ p.tareas ?? "—" }} {{ p.tareas === 1 ? "tarea" : "tareas" }} · {{ p.ejecuciones ?? "—" }} {{ p.ejecuciones === 1 ? "ejecución" : "ejecuciones" }} · {{ p.repeticiones ?? "—" }} rep.</dd></div>
                <div class="hom-resumen__ancho"><dt>Vara</dt><dd>rúbrica <code class="hom-mono">{{ p.hashRubrica || "—" }}</code> · suite <code class="hom-mono">{{ p.hashSuite || "—" }}</code> · prompts <code class="hom-mono">{{ p.hashPrompts || "—" }}</code></dd></div>
                <div class="hom-resumen__ancho"><dt>Comparado contra</dt><dd>
                  @if (p.esBaseline) {
                    Es un baseline.
                  } @else if (p.baselineRunId) {
                    {{ p.baselineNombreConfiguracion || "—" }} · corrida <code class="hom-mono">{{ p.baselineRunId }}</code> · capacidad @if (num(p.baselineCapacidad) !== null) { {{ p.baselineCapacidad | number: "1.1-1" }} } @else { — }
                  } @else {
                    Sin baseline.
                  }
                </dd></div>
                <div><dt>Veredicto del harness</dt><dd>{{ veredictoTexto(p.veredicto) }}</dd></div>
                <div><dt>Capacidad</dt><dd><strong>@if (num(p.capacidad) !== null) { {{ p.capacidad | number: "1.1-1" }} } @else { — }</strong> @if (num(p.deltaCapacidad) !== null) { ({{ conSigno(p.deltaCapacidad) }} pts) }</dd></div>
                <div class="hom-resumen__ancho"><dt>Huella SHA-256</dt><dd><code class="hom-mono hom-mono--corta">{{ p.huella || "—" }}</code> · {{ kb(p.tamanoBytes) }}</dd></div>
              </dl>

              @if (p.errores.length) {
                <div class="hom-lista hom-lista--error" role="alert">
                  <strong>No se puede cargar:</strong>
                  <ul>
                    @for (x of p.errores; track $index) {
                      <li>{{ x }}</li>
                    }
                  </ul>
                </div>
              }
              @if (p.avisos.length) {
                <div class="hom-lista hom-lista--aviso">
                  <strong>Avisos (se puede cargar igual):</strong>
                  <ul>
                    @for (x of p.avisos; track $index) {
                      <li>{{ x }}</li>
                    }
                  </ul>
                </div>
              }
            </div>
          }
        </div>

        <footer class="app-dialog__footer">
          <button type="button" class="app-form-btn app-form-btn--secondary" [disabled]="carga.cargando" (click)="cerrarCarga()">Cancelar</button>
          <button type="button" class="app-form-btn app-form-btn--primary" [disabled]="!puedeCargar" (click)="confirmarCarga()">
            {{ carga.cargando ? "Cargando…" : "Cargar" }}
          </button>
        </footer>
      </section>
    </div>
  }

  <!-- ========================== Cargar ficha del catálogo ========================== -->
  @if (cargaFicha) {
    <div class="hom-modal" role="dialog" aria-modal="true" aria-labelledby="hom-ficha-titulo" (keydown.tab)="atrapaFoco($event)" (keydown.shift.tab)="atrapaFoco($event)">
      <div class="hom-modal__fondo" (click)="cerrarCargaFicha(true)" (keydown.enter)="cerrarCargaFicha(true)"></div>
      <section class="app-dialog hom-modal__caja hom-modal__caja--ancha hom-modal__caja--carga">
        <header class="app-dialog__header">
          <div class="app-dialog__heading">
            <div>
              <p class="app-dialog__eyebrow">Cargar ficha del catálogo</p>
              <h2 id="hom-ficha-titulo">{{ cargaFicha.modelo.nombre }}</h2>
              <p><code class="hom-mono">{{ cargaFicha.modelo.identificador }}</code></p>
            </div>
          </div>
          <button type="button" class="app-dialog__close hom-cerrar" aria-label="Cerrar" [disabled]="cargaFicha.cargando" (click)="cerrarCargaFicha(true)">
            <i class="material-icons" aria-hidden="true">close</i>
          </button>
        </header>

        <div class="app-dialog__content hom-carga">
          <!-- En pantallas anchas: a la izquierda elegir y confirmar; a la derecha lo que se leyo. -->
          <div class="hom-carga__control">
            <ol class="hom-pasos" aria-label="Pasos">
              <li [class.is-activo]="!cargaFicha.plan" [class.is-hecho]="!!cargaFicha.plan">1 · Elegir archivo</li>
              <li [class.is-activo]="!!cargaFicha.plan">2 · Confirmar</li>
            </ol>

            <div class="hom-campo">
              <label for="hom-ficha-archivo">Ficha del catálogo (el JSON que exporta el Catálogo de Modelos de IA, hasta 256 KB)</label>
              <input id="hom-ficha-archivo" type="file" class="hom-input" accept=".json,application/json" [disabled]="cargaFicha.revisando || cargaFicha.cargando" (change)="alElegirFicha($event)" />
              <span class="hom-ayuda">Se revisa sin guardar nada. Si todo cuadra, «Cargar» manda el mismo archivo. La ficha informa: no cambia el veredicto ni el dictamen.</span>
            </div>

            @if (cargaFicha.revisando) {
              <p class="hom-nota" role="status">Revisando la ficha…</p>
            }

            @if (cargaFicha.plan; as p) {
              @if (p.pideMotivo && p.puedeCargar) {
                <div class="hom-campo">
                  <div class="hom-campo__cabeza">
                    <label for="hom-ficha-motivo">Motivo del reemplazo <span class="hom-req" aria-hidden="true">*</span></label>
                    <span id="hom-ficha-motivo-cuenta" class="hom-contador">mínimo {{ MOTIVO_FICHA_MINIMO }} · {{ cargaFicha.motivo.length }}/700</span>
                  </div>
                  <textarea id="hom-ficha-motivo" class="hom-input" rows="2" [minlength]="MOTIVO_FICHA_MINIMO" maxlength="700" [(ngModel)]="cargaFicha.motivo" [disabled]="cargaFicha.cargando" placeholder="El catálogo corrigió el precio del modo Fast." aria-describedby="hom-ficha-motivo-cuenta"></textarea>
                  <span class="hom-ayuda">La ficha #{{ p.idFichaReemplaza }}, verificada el {{ fechaDmy(p.verificadoReemplaza) }}, queda como reemplazada, visible en «Fichas de este modelo».</span>
                </div>
              }
            }

            <span class="hom-mensaje" role="alert" [attr.data-tono]="tonoCargaFicha">{{ mensajeCargaFicha }}</span>
          </div>

          @if (cargaFicha.plan; as p) {
            <div class="hom-carga__vista">
              <dl class="hom-resumen">
                <!-- Sin modelId no se leyo nada (se rechazo antes): sin la cuadricula de «—». -->
                @if (p.ficha?.modelId ? p.ficha : null; as x) {
                  <div class="hom-resumen__doble"><dt>Catálogo</dt><dd>{{ x.catalogo || "—" }}</dd></div>
                  <div><dt>Identificador del archivo</dt><dd><code class="hom-mono">{{ x.modelId || "—" }}</code></dd></div>
                  <div><dt>Modelo</dt><dd>{{ x.nombre || "—" }} · {{ x.empresa || "—" }}</dd></div>
                  <div><dt>Generada</dt><dd>{{ x.generado || "—" }}</dd></div>
                  <div><dt>Verificada</dt><dd>{{ fechaDmy(x.verificado) }}</dd></div>
                  <div><dt>Precio por millón de tokens</dt><dd>
                    @if (num(x.precioEntrada) !== null || num(x.precioSalida) !== null) { {{ x.moneda || "" }} }
                    @if (num(x.precioEntrada) !== null) { {{ x.precioEntrada | number: "1.2-6" }} entrada } @else { — }
                    @if (num(x.precioSalida) !== null) { · {{ x.precioSalida | number: "1.2-6" }} salida }
                  </dd></div>
                  <div><dt>Contexto · salida máxima</dt><dd>
                    @if (num(x.contextoTokens) !== null) { {{ x.contextoTokens | number: "1.0-0" }} tokens } @else { — } ·
                    @if (num(x.salidaMaxTokens) !== null) { {{ x.salidaMaxTokens | number: "1.0-0" }} tokens } @else if (x.salidaMaxTexto) { {{ x.salidaMaxTexto }} } @else { — }
                  </dd></div>
                  <div><dt>Índice del catálogo</dt><dd>@if (num(x.indiceInteligencia) !== null) { {{ x.indiceInteligencia | number: "1.0-2" }} · {{ x.indiceConfiguracion || "configuración no indicada" }} } @else { — }</dd></div>
                  <div><dt>Top del catálogo</dt><dd>@if (num(x.topRank) !== null) { #{{ x.topRank }} } @else { — }</dd></div>
                  <div><dt>Top de su categoría</dt><dd>@if (num(x.categoryRank) !== null) { #{{ x.categoryRank }} } @else { — }</dd></div>
                  <div><dt>Benchmarks</dt><dd>{{ x.benchmarks?.length ?? 0 }}</dd></div>
                  <!-- La página del modelo en el catálogo: liga solo si es https://; si no, el texto tal cual -->
                  <div class="hom-resumen__doble"><dt>En el catálogo</dt><dd>
                    @if (esHttps(x.enlace)) {
                      <a class="hom-enlace" [href]="x.enlace" [attr.title]="x.enlace" target="_blank" rel="noopener noreferrer">Ver en el catálogo</a>
                    } @else {
                      {{ x.enlace || "—" }}
                    }
                  </dd></div>
                }
                <!-- Sin «formato vN»: la ficha es el JSON del catálogo tal cual, sin versión propia -->
                <div><dt>Archivo</dt><dd>{{ p.nombreArchivo || "—" }} · {{ kb(p.tamanoBytes) }}</dd></div>
                <div class="hom-resumen__ancho"><dt>Huella SHA-256</dt><dd><code class="hom-mono hom-mono--corta">{{ p.huella || "—" }}</code></dd></div>
              </dl>

              @if (p.errores.length) {
                <div class="hom-lista hom-lista--error" role="alert">
                  <strong>No se puede cargar:</strong>
                  <ul>
                    @for (x of p.errores; track $index) {
                      <li>{{ x }}</li>
                    }
                  </ul>
                </div>
              }
              @if (p.avisos.length) {
                <div class="hom-lista hom-lista--aviso">
                  <strong>Avisos (se puede cargar igual):</strong>
                  <ul>
                    @for (x of p.avisos; track $index) {
                      <li>{{ x }}</li>
                    }
                  </ul>
                </div>
              }
            </div>
          }
        </div>

        <footer class="app-dialog__footer">
          <button type="button" class="app-form-btn app-form-btn--secondary" [disabled]="cargaFicha.cargando" (click)="cerrarCargaFicha()">Cancelar</button>
          <button type="button" class="app-form-btn app-form-btn--primary" [disabled]="!puedeCargarFicha" (click)="confirmarCargaFicha()">
            {{ cargaFicha.cargando ? "Cargando…" : "Cargar" }}
          </button>
        </footer>
      </section>
    </div>
  }
</div>
